module.exports = __webpack_public_path__ + "img/notification-icons.7bebaebf.svg";